<div class="spinner-border text-c100" role="status">
</div>
